import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "list",
  "use": "list-usage",
  "viewBox": "0 0 16 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 12\" id=\"list\">\n  <path fill-rule=\"evenodd\" d=\"M470.889,308.082h-9.365a1.082,1.082,0,1,1,0-2.164h9.365A1.082,1.082,0,1,1,470.889,308.082Zm0-4.853h-9.365a1.079,1.079,0,0,1-1.111-1.049,1.107,1.107,0,0,1,1.111-1.082h9.365A1.107,1.107,0,0,1,472,302.18,1.079,1.079,0,0,1,470.889,303.229ZM457.213,313A1.236,1.236,0,0,1,456,311.82a1.209,1.209,0,0,1,1.213-1.148,1.178,1.178,0,0,1,1.179,1.148A1.206,1.206,0,0,1,457.213,313Zm0-4.853a1.149,1.149,0,1,1,0-2.3A1.148,1.148,0,1,1,457.213,308.147Zm0-4.819A1.209,1.209,0,0,1,456,302.18a1.236,1.236,0,0,1,1.213-1.18,1.206,1.206,0,0,1,1.179,1.18A1.178,1.178,0,0,1,457.213,303.328Zm4.311,7.41h9.365a1.082,1.082,0,1,1,0,2.163h-9.365A1.082,1.082,0,1,1,461.524,310.738Z\" transform=\"translate(-456 -301)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/list.svg
// module id = null
// module chunks = 